import { Button } from 'antd';
import { CSSProperties, ReactNode } from 'react';
import { PlusOutlined } from '@ant-design/icons';

const PlusButton = ({
    children,
    onClick,
    className,
    style,
    plusBackgroundColor = 'var(--hcrx-medium-blue)',
    ...props
}: {
    children: ReactNode;
    onClick?: React.MouseEventHandler<HTMLElement> | undefined;
    className?: string;
    style?: CSSProperties;
    plusBackgroundColor?: string;
    [x: string]: any;
}) => {
    return (
        <Button
            // allow additional class from outside
            {...(className
                ? {
                      className: `${className} bg-transparent shadow-none border-0 d-flex align-items-center`,
                  }
                : {})}
            onClick={onClick}
            style={{
                fontWeight: 500,
                color: 'var(--hcrx-medium-blue)',
                fontSize: 16,
                ...style,
            }}
            {...props}
        >
            <PlusOutlined
                rev={undefined}
                style={{
                    backgroundColor: plusBackgroundColor,
                    height: 24,
                    width: 24,
                }}
                className="fs-6 p-1 rounded-circle fw-bold text-white"
            />

            {children}
        </Button>
    );
};

export default PlusButton;
